import { connect } from "react-redux";

// Component
import TimesheetMonthly from "./TimesheetMonthly";
// Actions
import {
  getDailyTimesheets,
  getOtherTimesheets,
  clearTimesheetList,
} from "../timesheetActions";
import { getOrganizationMembersList } from "../../Projects/projectsActions";
import { getOfficesShortList } from "../../Offices/officesActions";

// Store props to map with current state
const mapStateToProps = (state) => ({
  isLoading: state.timesheet.isLoading,
  dailyTimesheetLoading: state.timesheet.dailyTimesheetLoading,
  dailyTimesheets: state.timesheet.dailyList,
  timesheetsList: state.timesheet.list,
  profileData: state.profile.profileData,
});

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  getDailyTimesheets: (payload) => dispatch(getDailyTimesheets(payload)),
  getOtherTimesheets: (payload) => dispatch(getOtherTimesheets(payload)),
  getOfficesShortList: (payload) => dispatch(getOfficesShortList(payload)),
  getOrganizationMembersList: (payload) => dispatch(getOrganizationMembersList(payload)),
  clearTimesheetList: () => dispatch(clearTimesheetList()),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(TimesheetMonthly);
